import { serializeIdentifier } from "../../corePlugins/useChartSeries/serializeIdentifier.js";
export const isIdentifierVisible = (visibilityMap, identifier, seriesConfig) => {
  const uniqueId = serializeIdentifier(seriesConfig, identifier);
  return !visibilityMap.has(uniqueId);
};